import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API } from "../App";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { updateUser, setLoading } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      setLoading(true);

      // Read token from URL query param (from Google OAuth callback redirect)
      const token = searchParams.get("token");

      if (!token) {
        console.error("No token found in callback URL");
        navigate("/login", { replace: true });
        return;
      }

      // Store token in localStorage
      localStorage.setItem("session_token", token);

      try {
        // Fetch user info using the token
        const response = await fetch(`${API}/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }

        const userData = await response.json();
        updateUser(userData);

        // Navigate based on role
        if (userData.role === "super_admin") {
          navigate("/admin", { replace: true });
        } else if (userData.role === "team_member") {
          navigate("/team", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        localStorage.removeItem("session_token");
        navigate("/login?error=auth_failed", { replace: true });
      }
    };

    processAuth();
  }, [navigate, searchParams, updateUser, setLoading]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-[#475569] font-medium">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
